import { IRelatedWalletTransaction } from "./AnalyticsSlice";
import SmartList from "../components/SmartList";
import { ISorting } from "../dashboard/DashboardSlice";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import RelatedWalletTxListItem from "./RelatedWalletTxListItem";

interface IListProps {
    txList: Array<IRelatedWalletTransaction>;
    sorting: ISorting;
    setSorting: (sorting: ISorting) => void;
}

function RelatedWalletTxList(props: IListProps): JSX.Element {
    const { txList, sorting, setSorting } = props;

    const version = useSelector((state: any) => state.auth.version);
    const headerData = useMemo(() => {
        return [
            { fieldText: "Receiver", fieldValue: "receiver" },
            { fieldText: "Sender", fieldValue: "sender" },
            { fieldText: "Asset", fieldValue: "asset" },
            { fieldText: "Value (USD)", fieldValue: "volume" },
            { fieldText: "Date", fieldValue: "date" },
        ];
    }, [version]);

    const generateItem = (tx: IRelatedWalletTransaction, idx: number) => (
        <RelatedWalletTxListItem
            key={idx}
            receiver={tx.receiver}
            sender={tx.sender}
            asset={tx.asset}
            value={tx.volume * tx.price}
            transactionType={tx.transactionType}
            transactionDate={tx.transactionDate}
        />
    );

    return (
        <div className="table-container">
            <SmartList
                headerData={headerData}
                arr={txList}
                generateItem={generateItem}
                sorting={sorting}
                setSorting={setSorting}
                disabled={headerData
                    .filter((c) => !["date", "volume"].includes(c.fieldValue))
                    .map((c) => c.fieldValue)}
            />
        </div>
    );
}

export default RelatedWalletTxList;
